import icon from "images/logo-ifttt-white.svg?raw"
import parse from "html-react-parser"

export default function IftttLogoIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
